// Message templates API fetcher — Wave E.

import { apiClient } from './client';
import { endpoints } from './endpoints';
import type {
  RenderedTemplate,
  TemplateInfo,
  TemplateListResponse,
  UpdateTemplateInput,
} from '../types/api';

export interface ListTemplatesFilters {
  page: number;
  limit?: number;
  channel_type?: 'email' | 'sms' | 'whatsapp' | 'push';
  is_active?: boolean;
  q?: string;
}

export async function listTemplates(
  filters: ListTemplatesFilters,
): Promise<TemplateListResponse> {
  const params = new URLSearchParams();
  params.set('page', String(filters.page));
  if (filters.limit) params.set('limit', String(filters.limit));
  if (filters.channel_type) params.set('channel_type', filters.channel_type);
  if (filters.is_active !== undefined)
    params.set('is_active', filters.is_active ? '1' : '0');
  if (filters.q) params.set('q', filters.q);
  const res = await apiClient.get<TemplateListResponse>(
    `${endpoints.templates.list}?${params.toString()}`,
  );
  return res.data;
}

export async function getTemplate(uuid: string): Promise<TemplateInfo> {
  const res = await apiClient.get<{ template: TemplateInfo }>(
    endpoints.templates.detail(uuid),
  );
  return res.data.template;
}

export async function updateTemplate(
  uuid: string,
  input: UpdateTemplateInput,
): Promise<TemplateInfo> {
  const res = await apiClient.put<{ template: TemplateInfo }, UpdateTemplateInput>(
    endpoints.templates.update(uuid),
    input,
  );
  return res.data.template;
}

export async function previewTemplate(uuid: string): Promise<RenderedTemplate> {
  const res = await apiClient.get<{ rendered: RenderedTemplate }>(
    endpoints.templates.preview(uuid),
  );
  return res.data.rendered;
}
